export default function HowItWorks() {
  const steps = [
    {
      step: "01",
      icon: "ri-search-line",
      title: "Browse Categories",
      desc: "Explore our organized spreadsheet categories to find the product type you are looking for — from shoes and clothing to accessories and more.",
    },
    {
      step: "02",
      icon: "ri-file-search-line",
      title: "Research Products",
      desc: "Dive into detailed product listings with curated information that helps you understand options, features and value before making any decisions.",
    },
    {
      step: "03",
      icon: "ri-scales-3-line",
      title: "Compare Options",
      desc: "Compare different products side by side using structured spreadsheet data to identify the best match for your needs and budget.",
    },
    {
      step: "04",
      icon: "ri-shopping-bag-3-line",
      title: "Complete Purchase",
      desc: "Once you have found the perfect product, proceed through recommended platforms to complete your purchase with confidence.",
    },
  ];

  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-14">
            <span className="inline-flex items-center gap-2 px-3 py-1 bg-secondary-100 text-secondary-800 text-xs font-semibold rounded-full mb-5 whitespace-nowrap">
              <i className="ri-guide-line"></i>
              How It Works
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 text-balance">
              How Hipobuy Spreadsheet Works
            </h2>
            <p className="text-base text-foreground-500 max-w-xl mx-auto">
              Four simple steps to transform how you discover and shop for products
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((item, idx) => (
              <div key={item.title} className="relative group">
                <div className="p-6 rounded-2xl bg-background-100/80 border border-background-200/40 h-full">
                  <span className="text-5xl font-heading font-bold text-primary-200 group-hover:text-primary-300 transition-colors duration-300">
                    {item.step}
                  </span>
                  <div className="mt-4">
                    <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                      <i className={`${item.icon} text-xl text-primary-600`}></i>
                    </span>
                    <h3 className="text-lg font-bold text-foreground-950 mb-2">{item.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}